import { FC, useState } from 'react';
import { IconButton, Dialog, DialogTitle, DialogContent } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  title?: string;
  onChange?: (filter: any) => void;
}

const MobileFilterDialog: FC<React.PropsWithChildren<Props>> = ({ title, children }) => {
  const [filtersAnchorEl, setfiltersAnchorEl] = useState(null);
  const openFiltersMenu = Boolean(filtersAnchorEl);
  const handleFiltersMenuClick = (e) => {
    setfiltersAnchorEl(e.currentTarget);
  };
  const handleFiltersMenuClose = () => {
    setfiltersAnchorEl(null);
  };

  return (
    <div className="mobile-filter-dialog-group">
      <IconButton id="itemSearchFiltersButton" onClick={handleFiltersMenuClick}>
        <TuneIcon />
      </IconButton>
      <Dialog open={openFiltersMenu} onClose={handleFiltersMenuClose} className="mobile-filter-dialog" keepMounted={true}>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <b>{title}</b>
          <IconButton
            aria-label="close"
            onClick={handleFiltersMenuClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }} className="mobile-filter-dialog__content">
          {children}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default MobileFilterDialog;
